import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="criterion-period-form"
export default class extends Controller {

	static targets = [
		'goalType',
		'shouldLimitQuantitySection',
		'shouldLimitQuantityInput',
		'limitQuantitySection',
		'limitCountInput',
		'limitDurationInput',
	]

	static values = {
		countElementSelector:         { type: String, default: '.count-based-element' },
		durationElementSelector:      { type: String, default: '.duration-based-element' },
		limitQuantityElementSelector: { type: String, default: '.limit-quantity-element' },
		activitiesElementSelector:    { type: String, default: '.criterion-goal-activities' },
	}

	connect() {
		this.updateLayout()
	}

	updateLayout(_event) {
		switch (this.goalTypeTarget.value) {
			case 'attended_session_count':
				this.showActivities()
				this.showCountElements()
				this.hideDurationElements()
				this.shouldLimitQuantitySectionTarget.classList.remove('d-none')
				this.updateLimitQuantitySection()
				break;

			case 'attended_activity_duration':
				this.showActivities()
				this.hideCountElements()
				this.showDurationElements()
				this.shouldLimitQuantitySectionTarget.classList.remove('d-none')
				this.updateLimitQuantitySection()
				break;

			case 'attended_session_count_and_duration':
				this.showActivities()
				this.showCountElements()
				this.showDurationElements()
				this.shouldLimitQuantitySectionTarget.classList.remove('d-none')
				this.updateLimitQuantitySection()
				break;

			case 'facilitated_session_count':
				this.showActivities()
				this.showCountElements()
				this.hideDurationElements()
				this.shouldLimitQuantitySectionTarget.classList.remove('d-none')
				this.updateLimitQuantitySection()
				break;

			case 'facilitated_activity_duration':
				this.showActivities()
				this.hideCountElements()
				this.showDurationElements()
				this.shouldLimitQuantitySectionTarget.classList.remove('d-none')
				this.updateLimitQuantitySection()
				break;

			case 'facilitated_session_count_and_duration':
				this.showActivities()
				this.showCountElements()
				this.showDurationElements()
				this.shouldLimitQuantitySectionTarget.classList.remove('d-none')
				this.updateLimitQuantitySection()
				break;

			default:
				this.hideActivities()
				this.hideCountElements()
				this.hideDurationElements()
				this.shouldLimitQuantitySectionTarget.classList.add('d-none')
				this.updateLimitQuantitySection()
				break;
		}
	}

	showCountElements() {
		const countElements = this.element.querySelectorAll(this.countElementSelectorValue)
		countElements.forEach( (element) => { 
			element.classList.remove('d-none')

			element.querySelectorAll('input')
				.forEach((inputElement) => inputElement.disabled = false)
		})
	}
	
	hideCountElements() {
		const countElements = this.element.querySelectorAll(this.countElementSelectorValue)
		countElements.forEach( (element) => { 
			element.classList.add('d-none')

			element.querySelectorAll('input')
				.forEach((inputElement) => inputElement.disabled = true)
		})
	}

	showDurationElements() {
		const durationElements = this.element.querySelectorAll(this.durationElementSelectorValue)
		durationElements.forEach( (element) => { 
			element.classList.remove('d-none')

			element.querySelectorAll('input')
				.forEach((inputElement) => inputElement.disabled = false)
		})
	}
	
	hideDurationElements() {
		const durationElements = this.element.querySelectorAll(this.durationElementSelectorValue)
		durationElements.forEach( (element) => { 
			element.classList.add('d-none')

			element.querySelectorAll('input')
				.forEach((inputElement) => inputElement.disabled = true)
		})
	}

	updateLimitQuantitySection(_event) {
		if (this.shouldLimitQuantityInputTarget.checked) {
			this.limitQuantitySectionTarget.classList.remove('d-none')

			switch (this.goalTypeTarget.value) {
				case 'attended_session_count':
					this.limitCountInputTarget.disabled = false
					this.limitDurationInputTarget.disabled = true
					break;

				case 'attended_activity_duration':
					this.limitCountInputTarget.disabled = true
					this.limitDurationInputTarget.disabled = false
					break;

				case 'attended_session_count_and_duration':
					this.limitCountInputTarget.disabled = false
					this.limitDurationInputTarget.disabled = false
					break;

				case 'facilitated_session_count':
					this.limitCountInputTarget.disabled = false
					this.limitDurationInputTarget.disabled = true
					break;

				case 'facilitated_activity_duration':
					this.limitCountInputTarget.disabled = true
					this.limitDurationInputTarget.disabled = false
					break;

				case 'facilitated_session_count_and_duration':
					this.limitCountInputTarget.disabled = false
					this.limitDurationInputTarget.disabled = false
					break;

				default:
					this.limitCountInputTarget.disabled = true
					this.limitDurationInputTarget.disabled = true
					break;
			}
		} else {
			this.limitQuantitySectionTarget.classList.add('d-none')
		}
	}

	showActivities() {
		this.element
			.querySelectorAll(this.activitiesElementSelectorValue)
			.forEach( (element) => {
				element.classList.remove('d-none')
				element.querySelectorAll('input, select').forEach( (element) => element.disabled = false )
			})
	}

	hideActivities() {
		this.element
			.querySelectorAll(this.activitiesElementSelectorValue)
			.forEach( (element) => {
				element.classList.add('d-none')
				element.querySelectorAll('input, select').forEach( (element) => element.disabled = true )
			})
	}
}
